<template>
        <div id="g2Container">
                
        </div>
</template>

<script>
import { Chart } from '@antv/g2';
    export default {
        props:['speedData'],
        data(){
            return{
            }
        },
        watch:{
            speedData(){
                this.getG2View()
            }
        },
        mounted(){
            this.getG2View()
            // const e = document.createEvent('Event')
            // e.initEvent('resize', true, true)
            // window.dispatchEvent(e)
        },
        methods: {
            getG2View(){
                const chart = new Chart({
                    container: 'g2Container', // 指定图表容器 ID
                    autoFit: true,
                    padding:[5,12,30,20]
                });
                //去掉tickline
                chart.axis('speed',{
                    position:'left',
                    tickLine:null,
                    grid:null,
                    line: {
                        style: {
                            lineWidth:1,
                            stroke: '#414C73'
                        },
                    },
                })
                // 载入数据源
                chart.data(this.speedData);
                chart.scale({
                    //X轴设置
                    time: {
                        range: [0,1],
                        tickCount:5.5//显示的个数
                    }
                    
                });
                chart.axis('time', {
                    tickLine: null,
                    grid:null,
                    line:null
                });
                chart.tooltip({
                    // showTitle: false,
                    itemTpl: '<li><span style="background-color:{color};" class="g2-tooltip-marker"></span>{name}: {value}</li>',//定义标头
                    //设置样式
                    domStyles: {
                        'g2-tooltip': {
                            padding:'0px 12px 12px 12px'
                        }
                    }
                });
                //创建图形线条和区域
                chart.area().position('time*speed').color('l(270) 0:#2B3350 0.5:#00BB94 1:#00B38A');
                chart.line().position('time*speed').color('#00B38A').tooltip('speed', function (speed) {
                    return {
                        name: '超速',//itemTpl:{name}
                        value: speed// itemTpl:{value}
                    }
                });
                //渲染图表
                chart.render();
            }
        },
    }
</script>

<style lang="scss" scoped>
// .container{
//     width:100%;
//     height: 180px;
// }
#g2Container{
    width: 100%;
    height: 180px;
}
</style>